export default function abidePhoneNumberInputValidator($el, required, parent){
  const element = $el[0]
  const phoneNumberInputControllerElement = element.closest(`[data-controller="phone-number-input"]`)
  const controller = window.Stimulus.getControllerForElementAndIdentifier(phoneNumberInputControllerElement, "phone-number-input")
  controller.validatePhoneNumber()

  return controller.isValid
}
